import { Link } from 'react-router'
import { NOT_AFFILIATED_NOTICE } from '@pred-hub/shared/constants'
import { Logo } from '../components/brand/Logo.jsx'
import { Container, Eyebrow } from '../components/ui/primitives.jsx'

const YEAR = new Date().getFullYear()

const COLUMNS = [
  {
    title: 'Explore',
    links: [
      ['/events', 'Events'],
      ['/teams', 'Teams'],
      ['/players', 'Players'],
    ],
  },
  {
    title: 'Organize',
    links: [
      ['/organizers', 'Run an event'],
      ['/organizers', 'Get verified'],
    ],
  },
  {
    title: 'Pred Hub',
    links: [
      ['/faq', 'FAQ'],
      ['/support', 'Support'],
      ['/terms', 'Terms of Use'],
      ['/privacy', 'Privacy Policy'],
    ],
  },
]

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-hairline bg-page-2/60">
      <Container className="grid grid-cols-2 gap-10 py-12 md:grid-cols-[1.5fr_1fr_1fr_1fr]">
        <div className="col-span-2 space-y-4 md:col-span-1">
          <Logo />
          <p className="max-w-sm text-sm text-ink-muted">
            The community home for competitive Predecessor: events, brackets, teams and results in one place.
          </p>
        </div>
        {COLUMNS.map((column) => (
          <div key={column.title}>
            <Eyebrow as="h2">{column.title}</Eyebrow>
            <ul className="mt-4 space-y-2.5 text-sm">
              {column.links.map(([to, label]) => (
                <li key={label}>
                  <Link to={to} className="rounded text-ink-muted hover:text-ink">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </Container>
      <div className="border-t border-hairline">
        <Container className="flex flex-col gap-2 pt-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] text-xs text-ink-muted md:flex-row md:items-center md:justify-between">
          <p className="max-w-3xl">{NOT_AFFILIATED_NOTICE}</p>
          <p className="shrink-0">Community Developed · {YEAR}</p>
        </Container>
      </div>
    </footer>
  )
}
